import styled from 'styled-components';

const Paragraph = styled.p`
  margin-bottom:0px
`
export default Paragraph;